import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { GetPaidListMembers } from '@/connection/audiences/paid-lists';

export const fetchPaidListMembers = (create: ReducerCreators<AudiencesState>) =>
  create.asyncThunk(
    async ({ paidList, offset }: { paidList: string; offset: number }) => {
      return await GetPaidListMembers(paidList, offset);
    },
    {
      pending: (state) => {
        state.loadingPaidListMembers = true;
      },
      fulfilled: (state, action) => {
        state.paidListMembers = action.payload.members;
      },
      settled: (state) => {
        state.loadingPaidListMembers = false;
      },
    }
  );
